module.exports = {"TXTCLI_About_you":{"id":"TXTCLI_About_you","defaultMessage":"À propos de vous"}}